<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-account mc-account--login">
        <form class="mc-account__form mc-form" id="accountRegistration"  method="post" autocomplete="off">
          <div class="mc-form__body">
            <fieldset class="mc-form__fieldset">
              <div class="mc-form__field">
                <label class="mc-form__label" for="accountRegistrationSurname">
                  Фамилия
                  <span class="mc-form__asterisk">*</span>
                </label>
                <input class="mc-form__input" id="accountRegistrationSurname" type="text" name="surname" placeholder="Иванова" required>
              </div>
              <div class="mc-form__field">
                <label class="mc-form__label" for="accountRegistrationName">
                  Имя
                  <span class="mc-form__asterisk">*</span>
                </label>
                <input class="mc-form__input" id="accountRegistrationName" type="text" name="name" placeholder="Елена" required>
              </div>
              <div class="mc-form__field">
                <label class="mc-form__label" for="accountRegistrationPatronymic">
                  Отчество
                </label>
                <input class="mc-form__input" id="accountRegistrationPatronymic" type="text" name="patronymic" placeholder="Ивановна">
              </div>
              <div class="mc-form__field">
                <label class="mc-form__label" for="accountRegistrationEmail">
                  E-mail
                  <span class="mc-form__asterisk">*</span>
                </label>
                <input class="mc-form__input" id="accountRegistrationEmail" type="email" name="email" placeholder="example@mail.ru" required>
              </div>
              <div class="mc-form__field">
                <label class="mc-form__label" for="accountRegistrationGender">
                  Пол
                  <span class="mc-form__asterisk">*</span>
                </label>
                <div class="mc-form__radio-group">
                  <ul class="mc-form__radio-list">
                    <li class="mc-form__radio-item">
                      <div class="mc-form__radio-field">
                        <input class="mc-form__radio-input" id="genderF" type="radio" value="F">
                        <label class="mc-form__radio-label" for="genderF">Женский</label>
                      </div></li>
                    <li class="mc-form__radio-item">
                      <div class="mc-form__radio-field">
                        <input class="mc-form__radio-input" id="genderM" type="radio" value="M">
                        <label class="mc-form__radio-label" for="genderF">Мужской</label>
                      </div>
                    </li>
                    </ul>
                </div>
              </div>
              <div class="mc-form__field">
                <label class="mc-form__label">
                  Дата рождения
                  <span class="mc-form__asterisk">*</span>
                </label>
                <div class="mc-form__date mc-date">
                  <div class="mc-date__field">
                    <input class="mc-date__input" id="accountRegistrationBirthdayDay" type="text" name="day" placeholder="24" required>
                  </div>
                  <div class="mc-date__middle">
                    <button class="mc-date__select-button js-modal-button" data-target="accountRegistrationBirthdayMonth" type="button">
                      Сентябрь
                    </button>
                    <div class="mc-modal" id="accountRegistrationBirthdayMonth">
                      <div class="mc-modal__outer">
                        <div class="mc-modal__inner">
                          <div class="mc-modal__heading">
                            <button class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
                              <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
                                <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
                              </svg>
                            </button>
                            <div class="mc-modal__title">
                              Месяц
                            </div>
                          </div>
                          <div class="mc-modal__body">
                            <ul class="mc-filter__option-list mc-options">
                              <li class="mc-options__item">
                                <button class="mc-options__button" type="button">
                                  Январь
                                </button>
                              </li>
                              <li class="mc-options__item">
                                <button class="mc-options__button" type="button">
                                  Февраль
                                </button>
                              </li>
                              <li class="mc-options__item">
                                <button class="mc-options__button" type="button">
                                  Март
                                </button>
                              </li>
                              <li class="mc-options__item">
                                <button class="mc-options__button" type="button">
                                  Апрель
                                </button>
                              </li>
                              <li class="mc-options__item">
                                <button class="mc-options__button" type="button">
                                  Май
                                </button>
                              </li>
                              <li class="mc-options__item">
                                <button class="mc-options__button" type="button">
                                  Июнь
                                </button>
                              </li>
                              <li class="mc-options__item">
                                <button class="mc-options__button" type="button">
                                  Июль
                                </button>
                              </li>
                              <li class="mc-options__item">
                                <button class="mc-options__button" type="button">
                                  Август
                                </button>
                              </li>
                              <li class="mc-options__item">
                                <button class="mc-options__button isSelected" type="button">
                                  Сентябрь
                                </button>
                              </li>
                              <li class="mc-options__item">
                                <button class="mc-options__button" type="button">
                                  Октябрь
                                </button>
                              </li>
                              <li class="mc-options__item">
                                <button class="mc-options__button" type="button">
                                  Ноябрь
                                </button>
                              </li>
                              <li class="mc-options__item">
                                <button class="mc-options__button" type="button">
                                  Декабрь
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div class="mc-modal__bottom">
                            <button class="mc-button mc-button--color js-button-close" type="button">
                                                            <span class="mc-button__text">
                                                                Закрыть
                                                            </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mc-date__field">
                    <input class="mc-date__input" id="accountRegistrationBirthdayYear" type="text" name="year" placeholder="1990" required>
                  </div>
                </div>
              </div>
            </fieldset>
            <div class="mc-form__field">
              <input class="mc-form__checkbox" type="checkbox" name="checkbox" id="checkbox-0">
              <label class="mc-form__label" for="checkbox-0">
                Подписаться на рассылку
              </label>
            </div>
            <p class="mc-form__notice">
              Нажимая на кнопку "Завершить оформление" вы принимаете условия&nbsp;<a href="#">Публичной оферты</a>
            </p>
            <button class="mc-button mc-button--color" type="submit">
              Завершить регистрацию
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { MaskInput } from 'vue-3-mask';

export default {
  components: {
    MaskInput
  },
  beforeRouteLeave(to, from) {
    //if (to.name != 'login')
    //  this.$store.dispatch('unLoader');
  },
  created() {

  },
  computed: {

  },
  async mounted() {

  },
  methods: {
    auth: function(e) {
      if (this.sending === true)
        return;
      let formData = new FormData(),
          _this = this;
      let top = 0;
      this.error = [];
      this.error_text = [];

      formData.append('phone', this.phone);
      formData.append('code', this.code);

      if (!this.code) {
        this.error.push('code');
        top = document.querySelector(".field_code").offsetTop;
      }
      if (!this.phone) {
        this.error.push('phone');
        top = document.querySelector(".field_phone").offsetTop;
      }

      if (this.error.length == 0) {
        this.sending = true;
        formData.append('uuid', this.$store.getters.device_uuid);
        axios.post( '/mobileapp/api/user/login/',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        ).then(function(response){
          if (response.data.status == 'success') {
            let data = response.data.data;
            data.device = _this.$store.getters.device;
            data.uuid = _this.$store.getters.device_uuid;
            _this.$store.dispatch('Auth', data)
            _this.$router.push('/personal/');

          }
          else {
            _this.error_text = response.data.errors;
            _this.sending = false;
          }
        })
            .catch(function(){
              _this.sending = false;
            });
      }
      else {
        window.scrollTo(0, top);
      }
    },
  },
  data: () => ({
    error: [],
    sending: false,
    error_text: [],
  phone: '',
    code: '',
    step: 1
  }),
}
</script>
